module.exports = __webpack_public_path__ + "static/media/whitelogo.1c5914f3.png";